<template>
  <div class="mobile-footer-price-bar bg-white py-3 px-5">
    <div class="flex justify-between items-center gap-2">
      <slot></slot>
      <slot name="action-button">
        <nd-button type="primary" :disabled="!props.isSubmittable" @click="handleActionBtnClick">{{ props.actionText }}</nd-button>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  isSubmittable: boolean
  actionText: string
}>()

const emit = defineEmits<{
  (event: 'submit'): void
}>()

const handleActionBtnClick = () => {
  emit('submit')
}
</script>

<style lang="scss" scoped>
.mobile-footer-price-bar {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
}
</style>
